import {postRequest} from "./Request"
import config from "../config"

/**
 * Get all organization nodes details
 * @returns {Promise<any|{error: *}>} promise with error key or organization nodes object
 */
export const getOrganization = async () => {
    try {
        console.log('Fetching organization nodes...'); // Log the start of the request
        const response = await postRequest(config.API_URL + "/getorga");
        console.log('Response received getOrganization:', response); // Log the response for debugging
        return response;
    } catch (error) {
        console.error('Error fetching organization nodes:', error); // Log any error
        // Returning an error object to handle it in the calling function
        return { error: error || 'Failed to fetch organization nodes' };
    }
};


/***
 * Get all organization types used to get node type information (picto, label, level...)
 * @param orgaTypeUUID organization type unique identifier used to bind nodeType parameter to its type.
 * Retrieved from root node of getorga endpoint
 * @returns {Promise<any|{error: *}>} promise with error key or an array of modacs
 */
export const getOrgaTypes = async(orgaTypeUUID: string) => {
    const payload = JSON.stringify({
        "orgtypeUUID": orgaTypeUUID
    })
    console.log('getOrgaTypes payload :', payload)
    return await postRequest(config.API_URL + "/getorgtype", payload)
}

/***
 * Create a new area node on organization with specific type, specific label on a specific node
 * @param label new node text label to describe this node
 * @param nodeType type of node (type is retrieved from getorgtype endpoint)
 * @param path node path where new node will be added as children
 * @param reserve boolean indicating if this new node
 * @param orgTypeUUID organization type unique identifier used to bind nodeType parameter to its type
 * @returns {Promise<any|{error: *}>}
 */
 export const addNode = async(label:string, nodeType:string, path:string, reserve:boolean, orgTypeUUID:string) => {

    const body = JSON.stringify({
        label: label,
        type: nodeType,
        parentNode: path,
        store: reserve,
        orgtypeUUID: orgTypeUUID
    })
    console.log('addNode body :', body)
    return await postRequest(config.API_URL + "/addnode", body)
}


/***
 * Edit label or type of an area node
 * @param nodePath node path to edit ("xxxxxxxxxxxxx|yyyyyyyyyyyyyy|....)
 * @param label new node text label to describe this node
 * @param nodeType type of node (type is retrieved from getorgtype endpoint)
 * @param orgTypeUUID organization type unique identifier used to bind nodeType parameter to its type
 * @returns {Promise<any|{error: *}>} promise with error key or object response
 */
 export const editNode = async(nodePath:string, label:string, nodeType:string, orgTypeUUID:string) => {
    const body = JSON.stringify({
        node: nodePath,
        label: label,
        type: nodeType,
        orgtypeUUID: orgTypeUUID
    })
    console.log('editNode body :', body)
    const response = await postRequest(config.API_URL + "/editnode", body)
    if (response.error) {
        console.error("response error:", response.error)
    }
    return response 
}

/***
 * Delete a organization node
 * @param path node path to delete (this path should not contains child node or associated devices)
 * @param orgTypeUUID organization type unique identifier used to bind nodeType parameter to its type
 * @returns {Promise<any|{error: *}>} returns promise with error key or object response
 */
 export const deleteNode = async(path:string, orgTypeUUID:string) => {
    const body = JSON.stringify({
        node: path,
        orgtypeUUID: orgTypeUUID
    })
    console.log('deleteNode body :', body)
    return await postRequest(config.API_URL + "/deletenode", body)
}


/**
 * Get all Securispot references by calling /getsecurispotreferences.
 * The JWT is expected to be set in the request headers (e.g., via an interceptor).
 * The body/payload is an empty string ("").
 *
 * @returns {Promise<any|{error: *}>} A promise resolving to the response data or containing an error.
 */
export const getSecurispotReferences = async () => {
    // Your request body is an empty string:
    const payload = "";
  
    // Log or debug if needed:
    console.log('getSecurispotReferences payload:', payload);
  
    // POST request to your backend endpoint:
    // Assumes `postRequest` automatically includes headers with JWT.
    return await postRequest(config.API_URL + "/getsecurispotreferences", payload);
  };
  